import { ApiService } from '../../app-lite/api/api.service';

import VvGarageSettingsHtml from './vv-garage.settings.html';

export function VVGarageStates (
   $stateProvider : ng.ui.IStateProvider
) { 
  $stateProvider
  .state({
    controller : 'VVGarageSettingsCtrl',
    name       : 'app.vv-garage',
    templateUrl: VvGarageSettingsHtml,
    url        : '/vv_garage',
    resolve    : {
      integration        : ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/company_integrations'),
      vv_garage_locations: ( workshopAPI : ApiService ) : ng.IPromise<any> => workshopAPI.get('/vv_garage/get_location_list')
    }
  });
}